module.exports = __webpack_public_path__ + "static/media/LemonTablet.9da9729e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonTablet.png
// module id = 472
// module chunks = 0